export function openDownloadPdf(pdfDataBase64: string, filename: string): void {
	const blob = new Blob([pdfDataBase64], { type: 'application/pdf' })
	const link = document.createElement('a')
	link.style.display = 'none'
	link.href = URL.createObjectURL(blob)
	link.download = `${filename}.pdf`
	link.click()
}
